module.exports = __webpack_public_path__ + "static/media/logo-color.f5aef769.png";